import { render } from "./SidebarMenuSubItem.vue?vue&type=template&id=5cda467e&ts=true"
import script from "./SidebarMenuSubItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuSubItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuSubItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cda467e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cda467e', __exports__)) {
    api.reload('5cda467e', __exports__)
  }
  
  module.hot.accept("./SidebarMenuSubItem.vue?vue&type=template&id=5cda467e&ts=true", () => {
    api.rerender('5cda467e', render)
  })

}


export default __exports__